module.exports = __webpack_public_path__ + "darkyellow.a46eb14212b0739911c7.png";